import { render, staticRenderFns } from "./BaseImageTextButton.vue?vue&type=template&id=618c6a0c&scoped=true"
import script from "./BaseImageTextButton.vue?vue&type=script&lang=js"
export * from "./BaseImageTextButton.vue?vue&type=script&lang=js"
import style0 from "./BaseImageTextButton.vue?vue&type=style&index=0&id=618c6a0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618c6a0c",
  null
  
)

export default component.exports